import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Table, Skeleton, Select, Tooltip, Form, List, Card, Tabs, Menu, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import '../Toolbox.less';
/* import sampleFieldData from '../sampleFieldData.json'; */
import { execFetchFieldSampleVBQL } from '../../models/vbqlResults/vbqlResultsActions';
import Tool from '../../components/Tool';

const TABLE_COLUMNS = [{
  title: 'Value',
  dataIndex: 'value',
  key: 'value',
  sorter: (a, b) => a.value.localeCompare(b.value),
}, {
  title: 'Count',
  dataIndex: 'count',
  key: 'count',
  width: '80px',
  sorter: (a, b) => a.count - b.count,
}];

const SampleTable = styled(Table)`
  & .ant-table {
    border: none !important;
    background: #344554;
  }
  
  & .ant-table-thead th {
    background: #4D5E6D !important;
    border-bottom: 1px rgba(0, 0, 0, 0.2) solid !important;
  }
  
  & .ant-table-row td {
    border-color: rgba(0, 0, 0, 0.2) !important;
  }
  
  & .ant-table-row:hover td {
    background: rgba(255, 255, 255, 0.05) !important;
  }
  
  & .ant-table-placeholder {
    background: none;
  }
  
  & * {
    color: rgba(255, 255, 255, 0.8) !important;
    .ant-table-thead > tr > th .ant-table-column-sorter-up.on *, .ant-table-thead > tr > th .ant-table-column-sorter-down.on * {
      color: #64c5ff !important;
    }
  }
`;

const Section = styled.div`
  position: relative;
  display: flex;
  white-space: nowrap;
  flex-wrap: nowrap;
  align-items: center;
  padding: 8px 0;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  
  &:before, &:after {
    border-top: 1px rgba(255, 255, 255, 0.1) solid;
    content: "";
  }
  
  &:after {
    width 100%;
    margin-left: 10px
  }
  
  &:before {
    width: 20px;
    margin-right: 10px
  }
`;

const Field = styled.div`
  margin-bottom: 8px;
  background: #344554;
  border-radius: 8px;
  padding: 8px;
`;

const FieldLabel = styled.div`
  font-size: 8px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const mapStateToProps = (state, { projectionKey }) => {
  let resultsSample;
  const vbqlResult = (
    R
      .pathOr(
        [],
        ['vbqlResults', projectionKey, 'ids'],
        state,
      )
      .map(id => state.vbqlResults.byId[id])
      .pop()
  );

  if (vbqlResult) {
    resultsSample = (
      Object
        .entries(JSON.parse(R.pathOr('{}', ['data', '0', 'sample'], vbqlResult)))
        .map(pair => ({ value: pair[0], count: pair[1] }))
    );
  }

  return {
    resultsSample,
    isLoading: !!R.path(['vbqlResults', projectionKey, 'isLoading'], state),
  };
};

const mapDispatchToProps = (dispatch, { projectionKey, fieldName }) => ({
  getResultSample: () => dispatch(execFetchFieldSampleVBQL(projectionKey, fieldName)),
});

class SchemaFieldInspector extends React.Component {
  state = {
    selection: null,
    searchTerm: '',
    filteredFieldKeys: new Set(),
    expandedKeys: [],
  };

  componentDidMount() {
    const { getResultSample } = this.props;
    getResultSample();
  }

  onSelectField = (selection) => {
    this.setState({ selection: selection || null });
  };

  render() {
    const { selection, searchTerm, filteredFieldKeys, expandedKeys } = this.state;
    const { resultsSample, fieldName, fieldType, onBack, isLoading } = this.props;
    return (
      <Tool
        title="Schema"
        subTitle="Field Inspector"
        loading={isLoading}
        onBack={onBack}
      >
        <div style={{ padding: '16px' }}>
          <Tool.Skeleton active paragraph={{ rows: 10 }} loading={isLoading}>
            <Tool.Divider>Details</Tool.Divider>
            <Field>
              <FieldLabel>Name</FieldLabel>
              {fieldName}
            </Field>
            <Field>
              <FieldLabel>Type</FieldLabel>
              {typeof fieldType === 'object' ? 'object' : fieldType}
            </Field>
            <Tool.Divider>Top Values</Tool.Divider>
            <SampleTable
              bordered={false}
              pagination={false}
              size="small"
              dataSource={resultsSample || []}
              columns={TABLE_COLUMNS}
            />
          </Tool.Skeleton>
        </div>
      </Tool>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SchemaFieldInspector);
